<template>
  <div class="organisation-billing-line">
    <div class="organisation-billing-line__name">
      {{ localPaymentInfos.name }}
    </div>
    <BillingLineContent
      ref="content"
      v-model="localPaymentInfos"
      @disable-submit="emitDisableSubmit"
      @enable-submit="emitEnableSubmit"
      @disable-line-submit="emitInlineDisableSubmit"
      @enable-line-submit="emitInlineEnableSubmit"
    />
  </div>
</template>

<script>
import BillingLineContent from '@components/BillingLineContent';
import { mapGetters } from 'vuex';

export default {
  name: 'OrganisationBillingLine',
  components: { BillingLineContent },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['displayPaymentByCreditCard']),
    localPaymentInfos: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', { ...newValue });
      },
    },
  },
  mounted() {
    if (!this.displayPaymentByCreditCard) {
      this.$nextTick(() => this.$refs.content.$refs.iban.focus());
    }
  },
  methods: {
    emitDisableSubmit() {
      this.$emit('disable-submit');
    },
    emitEnableSubmit() {
      this.$emit('enable-submit');
    },
    emitInlineDisableSubmit() {
      this.$emit('disable-line-submit');
    },
    emitInlineEnableSubmit() {
      this.$emit('enable-line-submit');
    },
  },
};
</script>

<style lang="scss" scoped>
.organisation-billing-line {
  border: 1px solid $sk-grey-10;
  padding: 20px 16px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 16px;

  &__name {
    font-size: $fs-text-l;
    font-weight: $fw-semi-bold;
    line-height: 17px;
    padding-bottom: 21px;
  }
}
</style>
